/** disale tslint */
var bridgeName = 'WebViewJavascriptBridge';
var myWindow = window;
function setupWebViewJavascriptBridge(callback) {
    // WebViewJavascriptBridge 由native在注入  
    // https://github.com/marcuswestin/WebViewJavascriptBridge
    if (myWindow[bridgeName]) {
        return callback(myWindow[bridgeName]);
    }
    if (myWindow.WVJBCallbacks) {
        return myWindow.WVJBCallbacks.push(callback);
    }
    myWindow.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = "https://__bridge_loaded__";
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
}
export function callIOSHandler(event, params) {
    if (params === void 0) { params = {}; }
    return new Promise(function (resolve) {
        setupWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler(event, params, resolve);
        });
    });
}
export function iosGetCurrentBTYAddress() {
    return callIOSHandler('getCurrentBTYAddress');
}
export function iosSignRawTransaction(tx) {
    return callIOSHandler('sign', { createHash: tx });
}
export function iosSignTransactionGroup(tx, exer, withhold) {
    if (withhold === void 0) { withhold = 1; }
    return callIOSHandler('signTxGroup', { createHash: tx, exer: exer, withhold: withhold });
}
export function iosConfigPrivCache(cachePriv) {
    return callIOSHandler('configPriv', { cachePriv: cachePriv });
}
//# sourceMappingURL=iosJsBridge.js.map